"use client";

import capitalize from "lodash/capitalize";
import { usePathname } from "next/navigation";
import { Configure, useSearchBox } from "react-instantsearch";
import { SearchBar, type SearchBarProps } from "~/components/ui/SearchBar/SearchBar";

export const AlgoliaSearchbar = (props: SearchBarProps) => {
	const { query, refine, clear } = useSearchBox();
	const path = usePathname().substring(1);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		refine(e.target.value);
	};

	return (
		<>
			<SearchBar
				placeholder={
					"Søk blant " +
					(() => {
						// sanitize category name from pathname
						const cannonical = path.split("/")?.[path.split("/").length - 1];
						const underscoreArr = cannonical.split("_");
						const hyphenArr = underscoreArr?.[underscoreArr.length - 1]?.split("-");
						return capitalize(hyphenArr?.join(" "));
					})()
				}
				value={query}
				onChange={handleChange}
				clearValue={clear}
				{...props}
			/>
			<Configure enableRules={!query} />
		</>
	);
};
